// TODO - remove lint disable when editing this file
/* eslint-disable */
import { createReducer } from 'redux-ramda'
import {
  always,
  pipe,
  applySpec,
  pathOr,
  prop,
  flip,
  merge,
  assoc,
} from 'ramda'
import { createAction } from 'redux-actions'
import { ACTION_INIT } from './commonActions'

export const ACTION_WEBSKED_TASK_LOADED = 'ellipsis.websked.task.loaded'
export const setWebskedTasks = createAction(ACTION_WEBSKED_TASK_LOADED)

export const ACTION_WEBSKED_TASKS = 'ellipsis.actions.websked.tasks'
export const getWebskedTasks = createAction(ACTION_WEBSKED_TASKS)

export const ACTION_WEBSKED_NEW_TASK = 'ellipsis.actions.websked.newTask'
export const addWebskedNewTask = createAction(ACTION_WEBSKED_NEW_TASK)

export const ACTION_WEBSKED_PITCH_LOADED = 'ellipsis.websked.pitch.loaded'
export const setWebskedPitches = createAction(ACTION_WEBSKED_PITCH_LOADED)

export const ACTION_WEBSKED_PITCHES = 'ellipsis.actions.websked.pitches'
export const getWebskedPitches = createAction(ACTION_WEBSKED_PITCHES)

export const ACTION_WEBSKED_NEW_PITCH = 'ellipsis.actions.websked.newPitch'
export const addWebskedNewPitch = createAction(ACTION_WEBSKED_NEW_PITCH)

export const ACTION_WEBSKED_COLLECTION_LOADED =
  'ellipsis.websked.collection.loaded'
export const setCollections = createAction(ACTION_WEBSKED_COLLECTION_LOADED)

export const ACTION_WEBSKED_COLLECTIONS = 'ellipsis.actions.websked.collections'
export const getCollections = createAction(ACTION_WEBSKED_COLLECTIONS)

export const ACTION_WEBSKED_COLLECTIONS_ADD =
  'ellipsis.actions.websked.collectionsAdd'
export const addCollections = createAction(ACTION_WEBSKED_COLLECTIONS_ADD)

const initialState = {
  tasks: [],
}

export default createReducer(initialState, [
  [ACTION_INIT, () => always(initialState)],
  [
    ACTION_WEBSKED_TASK_LOADED,
    pipe(
      applySpec({
        tasks: pathOr([], ['tasks', 'data', 'results']),
        taskConfig: prop('taskConfig'),
      }),
      flip(merge)
    ),
  ],
  [
    ACTION_WEBSKED_PITCH_LOADED,
    pipe(
      applySpec({
        platformPitches: pathOr([], ['data', 'pitches']),
        publicationPitches: pathOr([], ['data', 'publicationPitches']),
      }),
      flip(merge)
    ),
  ],
  [ACTION_WEBSKED_COLLECTION_LOADED, assoc('collections')],
])
